import { DiscountTypes } from 'enums/menu';

const getRewardsDiscount = ({
  discounts,
}: {
  discounts?: Array<{ name?: string | null; value?: number | null }> | null;
}) =>
  (discounts || []).reduce(
    (acc, { name, value }) => (name === DiscountTypes.REWARDS_DISCOUNTS ? acc + (value ?? 0) : acc),
    0
  );

export default getRewardsDiscount;
